import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, useQueryStates } from 'nuqs';

export function useLOSQuestionListParams() {
  const [{ page, pageSize }, setParams] = useQueryStates({
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
  });

  const changePageNumber = (pageInput: number) => {
    setParams({ page: pageInput });
  };

  const changePageSize = (pageSizeInput: number) => {
    setParams({ page: 0, pageSize: pageSizeInput });
  };

  return [
    { page, pageSize },
    { changePageNumber, changePageSize },
  ] as const;
}
